/**
 * Kakao Chat service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxKakaoSvc', ItxKakaoSvc);

        ItxKakaoSvc.$inject = [
            'timestampSvc', 
            'ItxChatSvc',
            '$rootScope'
        ];

    function ItxKakaoSvc( timestampSvc, ItxChatSvc, $rootScope ) {
        var _this = this;

        var service = {
            close: _close
        };

        return service;

        function _close() {
            ItxChatSvc.closeKakaoChat();
            
            $rootScope.$broadcast('changeChatVisualizations', {
                event: 'showButton'
            });
        }
    }
})();
